const rootActionPath = 'core/InstoreHiwModal';

export const INSTORE_HIW_MODAL_TRIGGER = `${rootActionPath}/TRIGGER`;
export const INSTORE_HIW_MODAL_CLEAR = `${rootActionPath}/CLEAR`;

export const INSTORE_POST_LINK_TIPS_VIEW = `${rootActionPath}/VIEW`;
